/**
 * Riwayat navigasi in-app untuk tombol Back / Next di header.
 */
const stack = ref<string[]>([]);
const cursor = ref(-1);
let watching = false;

function normalizePath(fullPath: string) {
  const p = String(fullPath || '/').trim() || '/';
  return p.startsWith('/') ? p : `/${p}`;
}

function pushPath(fullPath: string) {
  const path = normalizePath(fullPath);
  const cur = stack.value[cursor.value];
  if (cur === path) return;
  if (cursor.value < stack.value.length - 1) {
    stack.value = stack.value.slice(0, cursor.value + 1);
  }
  stack.value.push(path);
  cursor.value = stack.value.length - 1;
}

export function useNavHistory() {
  const router = useRouter();
  const route = useRoute();

  const canBack = computed(() => cursor.value > 0);
  const canNext = computed(() => cursor.value >= 0 && cursor.value < stack.value.length - 1);

  function goBack() {
    if (!canBack.value) return;
    cursor.value -= 1;
    const target = stack.value[cursor.value];
    if (target && target !== route.fullPath) router.push(target);
  }

  function goNext() {
    if (!canNext.value) return;
    cursor.value += 1;
    const target = stack.value[cursor.value];
    if (target && target !== route.fullPath) router.push(target);
  }

  if (import.meta.client && !watching) {
    watching = true;
    if (!stack.value.length) pushPath(route.fullPath);
    watch(
      () => route.fullPath,
      (path) => {
        if (stack.value[cursor.value] === path) return;
        pushPath(path);
      }
    );
  }

  return {
    canBack,
    canNext,
    goBack,
    goNext,
  };
}
